<template>
  <div>
    <p v-if="error" role="alert">{{ error }}</p>
    <div v-if="timer" class="c-timer">
      <div class="c-timer__left">
        <div class="c-timer__display">{{ timer.label }}</div>
        <div class="c-timer__text">{{ timer.groups.join(', ') }} · {{ $t('displayTimer.' + timer.status) }}</div>
      </div>
      <div class="c-timer__time">{{ time }}</div>
      <div class="c-timer__buttons">
        <button type="button" class="c-button c-button--primary c-button--small" :disabled="busy"
                @click="control(timer.status === 'active' ? 'pause' : 'start')">
          {{ $t(timer.status === 'active' ? 'displayTimer.pause' : 'displayTimer.start') }}
        </button>
        <button type="button" class="c-button c-button--primary c-button--small" :disabled="busy" @click="control('reset')">
          {{ $t('displayTimer.reset') }}
        </button>
        <button type="button" class="c-button c-button--secondary c-button--small" :disabled="busy" @click="remove()">
          {{ $t('delete') }}
        </button>
      </div>
    </div>
    <form v-else @submit.prevent="create('active')">
      <sceTextField v-model="label" label="displayTimer.label" />
      <div class="c-input c-input--text">
        <label class="c-input__label">{{ $t('displayTimer.duration') }}</label>
        <timePicker v-model="timeObject" format="mm:ss" close-on-complete manual-input
                    input-class="c-input__field" input-width="100%" />
      </div>
      <fieldset class="c-input">
        <legend class="c-input__label">{{ $t('displayTimer.groups') }}</legend>
        <label v-for="group in groupOptions" :key="group" class="timer-group">
          <input type="checkbox" v-model="groups" :value="group" /> {{ group }}
        </label>
      </fieldset>
      <p v-if="!groupOptions.length">{{ $t('displayTimer.noGroups') }}</p>
      <button type="button" class="c-button c-button--secondary c-button--small" :disabled="busy || !valid" @click="create('prepare')">
        {{ $t('displayTimer.prepare') }}
      </button>
      <button type="submit" class="c-button c-button--primary c-button--small" :disabled="busy || !valid">
        {{ $t('displayTimer.start') }}
      </button>
      <button type="button" class="c-button c-button--secondary c-button--small" :disabled="busy" @click="$emit('close')">
        {{ $t('close') }}
      </button>
    </form>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import {timerText} from 'client/lib/displayTimer';

export default {
  name: 'timer',
  components: {timePicker: VueTimepicker},
  props: ['timer', 'ts'],
  data: function() {
    return {label: '', groups: [], timeObject: {mm: '03', ss: '00'}, now: Date.now(), clock: null, busy: false, error: ''};
  },
  computed: {
    groupOptions: function() {
      return [...new Set(this.$store.state.displays.items.map(display => display.timerGroup).filter(Boolean))].sort();
    },
    duration: function() {
      const {mm, ss} = this.timeObject;
      if (!/^\d+$/.test(mm) || !/^\d+$/.test(ss) || Number(ss) > 59) return 0;
      return Number(mm) * 60 + Number(ss);
    },
    valid: function() {
      return this.label.trim() && Number.isFinite(this.duration) && this.duration > 0 && this.groups.length &&
        this.groups.every(group => this.groupOptions.includes(group));
    },
    time: function() { return this.timer ? timerText(this.timer, this.now) : ''; },
  },
  created: function() {
    const tick = () => { this.now = this.ts ? this.ts.now() : Date.now(); };
    tick();
    this.clock = setInterval(tick, 200);
  },
  beforeDestroy: function() { clearInterval(this.clock); },
  methods: {
    run: async function(action) {
      if (this.busy) return;
      this.busy = true;
      this.error = '';
      try { await action(); }
      catch (error) { this.error = error.body?.error?.message || error.message || error.statusText || String(error); }
      finally { this.busy = false; }
    },
    create: function(status) {
      if (!this.valid) return;
      return this.run(async () => {
        await this.$store.dispatch('displayTimer.add', {
          eventId: this.$route.params.eventId,
          eventDisciplineId: this.$route.params.disciplineId,
          label: this.label.trim(), groups: this.groups, duration: this.duration, status, type: 'countdown',
        });
        this.$emit('close');
      });
    },
    control: function(action) {
      return this.run(() => this.$store.dispatch('displayTimer.control', {id: this.timer.id, action}));
    },
    remove: function() {
      return this.run(() => this.$store.dispatch('displayTimer.remove', {id: this.timer.id}));
    },
  },
};
</script>

<style scoped>
.timer-group { display: block; }
.c-timer { flex-wrap: wrap; }
.c-timer__buttons { flex-wrap: wrap; }
</style>
